// Этап 26.1: вход для сайта и git владельца. nginx на docs.* и git.* без сессии
// уводит сюда с ?return_to=<адрес>; после входа (Face ID или сертификат) приложение
// возвращает туда. Пускаем только https на свои поддомены docs.* и git.* — иначе
// параметр стал бы открытым редиректом.
export const PUBLISH_SUBDOMAINS = ['docs', 'git'];

export function publishReturnTarget(search, hostname) {
  let raw = null;
  try {
    raw = new URLSearchParams(search || '').get('return_to');
  } catch {
    return null;
  }
  if (!raw || !hostname) {
    return null;
  }
  let url;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' || url.username || url.password || url.port) {
    return null;
  }
  const allowed = PUBLISH_SUBDOMAINS.map((sub) => `${sub}.${hostname}`);
  return allowed.includes(url.hostname) ? url.href : null;
}
